let timer;

const debounce = (func, timeout = 300) => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    func.apply(this);
  }, timeout);
};

export default debounce;
